export const pick = (props, obj) => {
    return props.reduce((acc, prop) => {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
const SIZING_STYLE = [
    'borderBottomWidth',
    'borderLeftWidth',
    'borderRightWidth',
    'borderTopWidth',
    'boxSizing',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    // non-standard
    'tabSize',
    'textIndent',
    // non-standard
    'textRendering',
    'textTransform',
    'width',
    'wordBreak'
];
const getSizingData = (node) => {
    const style = window.getComputedStyle(node, null);
    if (style === null) {
        return null;
    }
    const sizingStyle = pick(SIZING_STYLE, style);
    const { boxSizing } = sizingStyle;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === '') {
        return null;
    }
    const paddingSize = parseFloat(sizingStyle.paddingBottom) +
        parseFloat(sizingStyle.paddingTop);
    const borderSize = parseFloat(sizingStyle.borderBottomWidth) +
        parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle,
        paddingSize,
        borderSize
    };
};
export default getSizingData;
